<template>
  <v-modal
    v-if="show"
    :show="show"
    @update:show="$emit('update:show', $event)"
    :isTableModal="true"
  >
    <h4 slot="header" class="title title-up">
      Einnahmen durch Werbung (ID: {{ id }})
    </h4>
    <affiliate-revenue-table :id="id"></affiliate-revenue-table>
  </v-modal>
</template>

<script lang="babel">
import AffiliateRevenueTable from "@/components/tables/AffiliateRevenueTable";
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    AffiliateRevenueTable,
    'v-modal': Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  }
};
</script>
